import { Channel } from '@/libraries/channel.ts';

const channel = Channel.getInstance('ally');

export default {
	async deleteActionitem({ commit, state }: any, id: number): Promise<any> {
		const response = await channel.emit({
			command: '/actionitems/deleteActionitem',
			to: 'background',
			args: [ id ],
		});
		const list = state.list.filter((item: any) => {
			if (item.id === id) {
				// don't return
			} else {
				return true;
			}
		});
		commit('SET_LIST', list);
	},
	updatePreview({ commit, state }: any): void {
		switch (state.launcherState) {
			case 'INPUT':
				channel.emit({
					to: 'background',
					command: 'updateUserInputForPreview',
					args: [state.storeInputText]
				});
				break;
		}
	},
	setPreviewState({ commit }: any, previewState: string): void {
		commit('SET_PREVIEW_STATE', previewState);
	}
};
